<template>
    <button class="btn-for-chosing"
        :class="{
            [direction]: true,
            [`type-${type}`]: true,
            [`lang-${locale}`]: true,
            'big-btn': type == 'a',
            'playing': hilo.isStatusPlay,
        }"
        v-click-and-rest
        :dismark="disabled"
        :disabled="disabled"
    >
        <template v-if="type === 'a'">
            <IconSvgUse file-name="hilo" size="16px" 
                :class="sIconName"
                :use="sIconName"
            />
            <template v-if="hilo.isStatusPlay">
                <span class="center-words" >
                    {{sButtonWord}}
                    <br/>
                    {{oPercent[direction]}}
                </span>
                <span>
                    {{oMultiple[direction]}}
                </span>
            </template>
            <template v-else>
                {{ wordsNotJoin }}
            </template>
        </template>
        <!--
            ↑ a 桌面端
            ↓ b 移动端
        -->
        <template v-else>
            <IconSvgUse
                class="bg-svg"
                fileName="hilo"
                :use="`hilo-btn-${direction}`"
            />
            <span class="text">
                <template v-if="hilo.isStatusPlay">
                    <IconSvgUse
                        file-name="hilo"
                        size="20px"
                        :class="sIconName"
                        :use="sIconName"
                    />
                    <span>
                        <em class="bet-way-word">
                            {{ sButtonWord }}
                        </em>
                        {{ locale == 'cn' ? $t('hilo.Probability')  : ''}}
                        {{oPercent[direction]}}
                        <br/>
                        {{ locale == 'cn' ? $t('hilo.Coefficient') : ''}}
                        {{oMultiple[direction]}}
                    </span>
                </template>
                <template  v-else>
                    {{ wordsNotJoin }}
                </template>
            </span>
        </template>
    </button>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import {useJoinStateStore} from '~/stores/cansino/joinState';

const oJoinStateStore = useJoinStateStore();
const {t: $t} = useI18n();

const props = defineProps({
    direction: String, // up, down
    disabled: Boolean, // 禁用 
    type: {
        type: String,
        default: 'a', // a, b
    },
});

// ↓ 注入你组件响应式的值
const hilo: any = inject('hilo');
const locale = useNuxtApp().$i18n.locale;
// 查询 RTP
const fTheRTP = computed(() => {
    let rtp = oJoinStateStore?.config?.rtp;
    let fRTP = Number.parseFloat(rtp || '0') / 100;
    // console.log("改版前取的旧值：", oJoinStateStore?.config?.houseEdge);
    console.log("RTP 新值：", fRTP);
    return fRTP;
});

// ↓ 扑克号：1-13
const iCardOrder = computed(() => {
    // hilo.sCardOrder 的值示例：♠4 
    if (!hilo.sCardOrder) return 0;
    return Number(hilo.sCardOrder.slice(1));
});

// ↓ 当极限号出现时显示 “same” 文字
const isShowSame = computed(()=>{
    if (!hilo.isStatusPlay) return; // 没在游戏中不显示等号
    const letterA = 1 === iCardOrder.value;
    const letterK = 13 === iCardOrder.value;
    console.log("letter: AK", letterA, letterK);
    if (props.direction === 'up' && letterK){
        return true
    }
    return props.direction === 'down' && letterA
});

// ↓ 当极限号出现时显示 “same” 图标
const sIconName = computed(()=>{
    if (isShowSame.value) return 'hilo-icon-equal';
    return `hilo-icon-arrow-${props.direction}`;
});

// ↓ 按钮文字 （下注期间）
const sButtonWord = computed(()=>{
    if (isShowSame.value) {
        return $t('hilo.Same');
    }
    if (props.direction === 'up'){
        return $t(
            1 === iCardOrder.value // A 牌
            ? 'hilo.Higher' // 高
            : 'hilo.HigherOr' // 高或相同
        );
    }
    return $t(
        13 === iCardOrder.value // K 牌 
        ? 'hilo.Lower' // 低 
        : 'hilo.LowerOr' // 低或相同 
    );
});


// ↓ 按钮文字 （未能加游戏期间）
const wordsNotJoin = computed(()=>{
    if (props.direction === 'up'){
        return $t('hilo.HigherOr');
    }
    return $t('hilo.LowerOr');
});

// ↓ 返回赔率信息（倍数）
const oMultiple = computed(()=>{
    const oLast = hilo.round.at(-1);
    if (!oLast) return {};
    return {
        up: oddHigher.value + 'x',
        down: oddLower.value + 'x',
    };
});

// ↓ 返回胜率信息（百分数）
const oPercent = computed(()=>{
    if (!iCardOrder.value) return {};
    return {
        up: (getMulti(iCardOrder.value, 0) * 100).toFixed(2) + '%',
        down: (getMulti(iCardOrder.value, 1) * 100).toFixed(2) + '%',
    };
});


// ↓ 押高赔率
const oddHigher = computed(()=> {
    if ('mini') {
        return betOnHigher(iCardOrder.value);
    }
    const multi = getMulti(iCardOrder.value, 0);
    const step01 = 13 * fTheRTP.value / (13 / (1 / multi));
    const step02 = trimFloat(step01, 2);
    return step02;
});

// ↓ 押低赔率
const oddLower = computed(()=> {
    if ('mini') {
        return betOnLower(iCardOrder.value);
    }
    const multi = getMulti(iCardOrder.value, 1);
    const fResult = 13 * fTheRTP.value / (13 / (1 / multi));
    return trimFloat(fResult, 2);
});

// ↓ 用此方法修剪小数点，防止发生“五入”  
const trimFloat = (amount = 0, pow = 0) => {
    const lfl = (
        amount.toString().includes(".")
        ? amount.toString().split(".").pop().length
        : 0
    );
    if (pow < lfl) {
        return amount.toString().slice(0, -(lfl - pow));
    }
    return amount;
};

// ↓ 计算胜率（旧版）
function getMulti(checkCard, side) {
    // side=0 押高
    // side=1 押低
    const acc = [[
        // ↓ 押高 -------------
        0,
        12 / 13,
        12 / 13,
        11 / 13,
        10 / 13,
        9 / 13,
        8 / 13,
        7 / 13,
        6 / 13,
        5 / 13,
        4 / 13,
        3 / 13,
        2 / 13,
        1 / 13,
    ], [
        // ↓ 押低 ------------
        0,
        1 / 13,
        2 / 13,
        3 / 13,
        4 / 13,
        5 / 13,
        6 / 13,
        7 / 13,
        8 / 13,
        9 / 13,
        10 / 13,
        11 / 13,
        12 / 13,
        12 / 13,
    ]];
    return acc[side][checkCard];
}

// ↓ 这 2 个方法是与后端工程相同的，一方修改另一方也需要修改成相同的值
// ↓ betOnHigher, betOnLower
function betOnHigher(card:number) {
    return [
        1.06,
        1.06,
        1.15,
        1.27,
        1.41,
        1.59,
        1.82,
        2.12,
        2.54,
        3.18,
        4.24,
        6.37,
        12.74,
    ][card-1];
}

function betOnLower(card:number) {
    return [
        12.74,
        6.37,
        4.24,
        3.18,
        2.54,
        2.12,
        1.82,
        1.59,
        1.41,
        1.27,
        1.15,
        1.06,
        1.06,
    ][card-1];
}


</script>

<style scoped lang="scss">
.btn-for-chosing{
    font-weight: 600;
    font-size: 18px;
    text-transform: uppercase;
    pointer-events: none;
    color: #6d809d;
    user-select: none;
    position: relative;
    &[class ~= playing]{
        cursor: pointer;
        pointer-events: auto;
    }
    svg[class *= -equal]{
        stroke: currentColor;
    }
}

// 👇颜色变量来自上 hilo 游戏，将来视情况转移到本组件内部
.playing[class~=up]{
    color: var(--hilo-yellow);
}
.playing[class~=down]{
    color: var(--color_blue);
}


.btn-for-chosing[class~=type-a]{
    border: 1px solid; // 彩色继承 color 
    background-color: #161f2c;
    justify-content: flex-start;
    @media screen and (max-width: 767px) {
        &{
            padding-left: 18px !important;
            padding-right: 18px !important;
        }
    }
    svg{
        margin: 0 6px 0 0;
    }
    &[class~=playing]{
        justify-content: space-between;
        &:hover{
            background-color: #242d44;
        }
    }
}

.btn-for-chosing[class~=type-b]{
    font-size: 15px;
    .bet-way-word{
        display: block;
    }
    &.lang-en{
        .bet-way-word{
            font-size: 13px;
            letter-spacing: -1px;
        }
    }
    .bg-svg{
        width: 162px;
        height: 94px;
        stroke: currentColor;
    }
    .text{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;  
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        line-height: 1.3;
        .svg-use{
            display: inline-block;
            margin: 0 5px 0 -7px;
        }
    }
    &[class~=playing]{
        .text{
            flex-flow: row nowrap;
        }
    }
    &[class~=up]{
        .text{
            padding-top: 14px;
        }
    }
    &[class~=down]{
        .text{
            padding-bottom: 8px;
        }
    }
}


</style>


